import React from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { Poppins } from 'src/common';
import { useStateSelector } from 'src/redux';

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;

  .toast-icon {
    flex-shrink: 0;
  }
`;

const ErrorIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" style={style}>
      <rect
        x="0.807692"
        y="0.807692"
        width="19.3846"
        height="19.3846"
        rx="9.69231"
        fill={colors.error}
        stroke={colors.error}
        strokeWidth="1.61538"
      />
      <path d="M7 7L14 14M14 7L7 14" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

const DEFAULT_MESSAGE = 'Something went wrong';

interface ErrorToastProps {
  message?: string;
}

const ErrorToastContent: React.FC<ErrorToastProps> = ({ message }) => {
  return (
    <Div>
      <div className="toast-icon">
        <ErrorIcon style={{ width: 32, height: 32 }} />
      </div>
      <Poppins weight={600}>{message || DEFAULT_MESSAGE}</Poppins>
    </Div>
  );
};

export const showErrorToast = (message?: string) => {
  toast(<ErrorToastContent message={message} />, {
    type: 'error',
    icon: false,
  });
};
